import Component from '../abstracts/Component';

import queryString from 'query-string';
import Observer from "../utils/Observer";
import {replacePageInHistory} from "../utils/BrowserHistoryUtils";

export default class InfiniteScrollComponent extends Component {
  get SELECTORS() {
    return {
      main: '[data-infinite-scroll]',
      trigger: '[data-infinite-scroll-trigger]',
      resultContainer: '.js-filters-result'
    }
  }

  constructor() {
    super();
    const searchObj = queryString.parse(location.search);
    const preload = searchObj.preload;
    const page = parseInt(searchObj.page);
    this.wasPreloaded=preload || page>0 || false;
    this.startPage=this.wasPreloaded?page+1:1;
  }

  observeScroll() {
    console.log("unobserver scroll")
    this.unobserverScroll();
    console.log("observer scroll")
    this.internalObserveScroll();
  }

  internalObserveScroll(){
    this.scroolObserver = new Observer('.footer-main', 400, null, (entries, observer) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {

          let mainDataset = document.querySelector(this.SELECTORS.main).dataset;
          let lastPage = mainDataset.infiniteScrollLastpage;
          let query = mainDataset.infiniteScrollQuery;
          let parsedQueryPage = queryString.parse(query).page;
          if (parseFloat(parsedQueryPage) <= parseFloat(lastPage)) {
            this.getPaginatedResult(query);
          } else {
            observer.unobserve(entry.target);
          }
        }
      });
    });
  }

  unobserverScroll(){
    if(this.scroolObserver){
      this.scroolObserver.unObserve();
      return;
    }
  }

  getPaginatedResult(query) {
    $.ajax({
      type: 'GET',
      url: query
    }).then(res => {
      let newURL = query.replace("isRefineSearch=true", "isRefineSearch=false");
      replacePageInHistory(newURL.replace(/\s.*/, ""),{},"", true);

      let response = new DOMParser().parseFromString(res, 'text/html').querySelector(this.SELECTORS.resultContainer);
      let container = document.querySelector(this.SELECTORS.resultContainer);
      let rows = response.querySelectorAll('.products-row');
      console.debug('loaded', rows.length, 'rows');
      this.$emit(this.$customEvents.TRACKING.loadMore, res);
      rows.forEach(child => {
        container.append(child);
      });

      this.enhancePage();

    }).fail(()=>{
      this.unobserverScroll();
    });
  }

  replaceButton(button, hide) {
    return new Promise((resolve, reject) => {
      try {
        let mainParent = document.querySelector(this.SELECTORS.main).parentElement;
        let query = document.querySelector(this.SELECTORS.main).dataset.infiniteScrollQuery;
        let newButton = null;
        if (button) {
          mainParent.innerHTML = button;
          newButton = document.querySelector(this.SELECTORS.main);
          newButton.setAttribute('data-infinite-scroll-query', query);
          mainParent.style.display = hide ? 'none' : '';
        }

        resolve(true)
      } catch (e) {
        reject(e)
      }
    });
  }

  enhancePage() {
    const main = document.querySelector(this.SELECTORS.main);
    let parsedQuery = queryString.parse(document.querySelector(this.SELECTORS.main).dataset.infiniteScrollQuery);
    parsedQuery.page = parseFloat(parsedQuery.page) + 1;
    main.setAttribute('data-infinite-scroll-query', `?${queryString.stringify(parsedQuery)}`);
  }

  setBaseQueryValue(query) {
    return new Promise((resolve, reject) => {
      try {
        const main = document.querySelector(this.SELECTORS.main);
        main.setAttribute('data-infinite-scroll-query', query);
        resolve(true)
      } catch (e) {
        console.debug(e);
        reject(false);
      }
    });
  }

  bindEvents() {

    this.$on(this.$customEvents.FILTERS_EVENTS.updated, ({
                                                           event,
                                                           payload
                                                         }) => {
      // console.log('ON EVENTO FILTERS UPDATED');
      if (payload.query) this.setBaseQueryValue(payload.query).then(res => {
        if(!payload.skipScroll){
          this.observeScroll()
        }
      });
      this.replaceButton(payload.updatedButton, payload.hideButton).then(res => {
        this.bindClickOnce();
      });

      //this.bindClickOnce();
    });

    this.bindClickOnce();

  }



  bindClickOnce() {
    this.$one('click.is', ({
                             event
                           }) => {
      event.currentTarget.classList.add('d-none');
      this.$emit(this.$customEvents.INFINITE_SCROLL_EVENTS.next, {
        page: this.startPage
      });
    }, this.SELECTORS.main);
  }

  render() {
    if (document.querySelector(this.SELECTORS.main)) this.bindEvents();
  }
}
